import styled from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/toyota/Button";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import {
    lineClampStyle,
    type LineClampStyleType,
} from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/LineClamp";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";

export const Header = styled(Flex.Row)`
    text-align: start;
    ${Button.Link} {
        margin-left: ${theme.space[2]}px;
    }

    html[dir="rtl"] & {
        ${Button.Link} {
            margin-left: 0;
            margin-right: ${theme.space[2]}px;
        }
    }
`;

export const Description = styled(Type.Text)<LineClampStyleType>`
    ${lineClampStyle};
`;
